import { render, staticRenderFns } from "./@PopupSectionTaskGalleryEdit.vue?vue&type=template&id=a95ef672&scoped=true&"
import script from "./@PopupSectionTaskGalleryEdit.vue?vue&type=script&lang=js&"
export * from "./@PopupSectionTaskGalleryEdit.vue?vue&type=script&lang=js&"
import style0 from "./@PopupSectionTaskGalleryEdit.vue?vue&type=style&index=0&id=a95ef672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95ef672",
  null
  
)

export default component.exports